<template>
  <div style="width: 70%; margin: 0 auto;">
    <el-card shadow="always">
      <h2 style="text-align: center;">{{ questionnaireData.title }}</h2>
      <el-descriptions :column="2"  border >
        <el-descriptions-item label="参与对象">
          {{ questionnaireData.participants }}
        </el-descriptions-item>
        <el-descriptions-item label="已参与人数">
          {{ questionnaireData.participants_count }}人
        </el-descriptions-item>
        <el-descriptions-item label="开始时间">
          {{ questionnaireData.start_time }}
        </el-descriptions-item>
        <el-descriptions-item label="结束时间">
          {{ questionnaireData.end_time }}
        </el-descriptions-item>
      </el-descriptions>
    <!-- 问卷描述 -->
      <h3>问卷描述：</h3>
      <div v-html="questionnaireData.description" class="content-section"></div>
        
    <!-- 问题列表 -->
      <h3>问卷问题：</h3>
      
      <div class="questions-list">
        <el-collapse>
          <el-collapse-item 
            v-for="(question, index) in questionnaireData.question" 
            :key="question.id"
            :name="question.id"
            :border="false"
          >
            <template slot="title">
            
              {{  `问题 ${index + 1}：${question.title}` }} <el-tag type="warning" size="mini">{{ question.question_type_text }}题</el-tag>
            </template>
            {{ question.options_str }}
          </el-collapse-item>
        </el-collapse>
      </div>
        
    <!-- 问卷结束语 -->
      <h3>问卷结束语：</h3>
      <div v-html="questionnaireData.afterword" class="content-section"></div>
    </el-card>
  </div>
</template>

<script>
import { getSurveyDetail} from "@/api/sys";

export default {
  name: 'QuestionnaireDetail',
  data() {
    return {
      questionnaireData: {}
    };
  },
  created() {
    const surveyId = this.$route.query.id;
    if (surveyId) {
      this.getDetail(surveyId);
    }
  },
  methods: {
    getDetail(id) {
      getSurveyDetail({ id }).then(res => {
          if (res && res.data) {
            this.questionnaireData = res.data;
          }
        })
        .catch(err => {
          console.error('获取问卷详情失败:', err);
          this.$message.error('获取问卷详情失败，请重试');
        });
    },
    // 解析选项字符串
    parseOptions(optionsStr) {
      if (!optionsStr) return [];
      return optionsStr.split(/[A-Z]：/).filter(option => option.trim() !== '');
    },
  }
};
</script>

<style scoped>
/* 内容区域通用样式 */
.content-section {
  padding: 10px;
  line-height: 1.8;
  color: #303133;
  border: 1px dotted #33bea7;
}

/* 问题列表样式 */
.questions-list {
  padding: 10px 0;
}

/* 选项列表样式 */
.options-list {
  margin-top: 10px;
}

.option-item {
  margin-bottom: 10px;
  align-items: center;
}

.option-letter {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #33bea7;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
}

.option-content {
  padding-left: 10px;
  line-height: 30px;
}

/* 标题样式补充 */
h2 {
  margin: 0 0 15px;
  font-size: 1.5rem;
  font-weight: bold;
}

h3 {
  margin: 20px 0 10px;
  font-size: 1.2rem;
  font-weight: bold;
  color: #303133;
}
</style>
    